<template>
  <div class="cookie-wrapper" :style="{ transform: `scale(${ isPc ? rate : 1 })` }" v-if="show">
    <div class="cookie">
      <div class="left">
        <div class="top">{{ En ? 'This website uses cookies to improve user experience. By using our website, you consent to all cookies in accordance with our Cookie Policy.' : '本网站使用 Cookie 来改善用户体验。使用我们的网站，即表示您同意根据我们的 Cookie 政策使用所有 Cookie。' }}</div>
        <a href="javascript:void(0)" @click="moreFn">{{ En ? 'Read more' : '阅读更多' }}</a>
      </div>
      <div class="btns">
          <div class="btn" @click="closeFn">
            {{ En ? 'Accept All' : '全部接受' }}
            <img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
            <img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
          </div>
          <div class="btn" @click="closeFn">
            {{ En ? 'Reject all' : '全部拒绝' }}
            <img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
            <img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  props: {
    rate: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      show: !localStorage.getItem('cookie')
    }
  },
  methods: {
    moreFn() {
      this.$router.push('/match_process?pageType=policy&headIndex=0&leftIndex=首页')
    },
    closeFn() {
      this.show = false
      localStorage.setItem('cookie', '1')
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .cookie-wrapper {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 1920px;
    transform-origin: left bottom;
    padding: 0 40px 40px;
  }
  
  .cookie {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0px 10px 20px 0px rgba(11,36,63,0.1);
    border-radius: 24px;
    padding: 0 40px;

    .left {
      flex: 1;

      .top {
        font-family: Inter, syn;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        line-height: 27px;
        text-align: left;
        font-style: normal;
      }

      a {
        display: block;
        text-decoration: underline;
        font-family: Inter, syn;
        font-weight: 500;
        font-size: 18px;
        color: #0B243F;
        line-height: 27px;
        text-align: left;
        font-style: normal;
      }
    }

    .btns {
				display: flex;

				.btn {
					height: 56px;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: 12px;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: 16px;
					color: #0B243F;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					padding: 0 28px 0 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 16px;
					cursor: pointer;

          &:last-child {
            margin-right: 0;
          }

					img {
						width: 24px;
						height: auto;
						margin-left: 12px;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .cookie-wrapper {
    position: fixed;
    z-index: 999;
    left: 0;
    bottom: 0;
    width: 100%;
    transform-origin: left bottom;
    padding: 0 .24rem .6rem;
  }
  
  .cookie {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 10px 20px 0px rgba(11,36,63,0.1);
    border-radius: .28rem;
    padding: .28rem .28rem .28rem;

    .left {

      .top {
        font-family: Inter, syn;
        font-weight: 500;
        font-size: .24rem;
        color: #333333;
        line-height: .36rem;
        text-align: left;
        font-style: normal;
      }

      a {
        display: block;
        text-decoration: underline;
        font-family: Inter, syn;
        font-weight: 500;
        font-size: .24rem;
        color: #0B243F;
        line-height: .36rem;
        margin-top: .08rem;
        text-align: left;
        font-style: normal;
      }
    }

    .btns {
				display: flex;
        margin-top: .28rem;

				.btn {
					height: .8rem;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: .2rem;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: .24rem;
					color: #0B243F;
					line-height: .24rem;
					text-align: left;
					font-style: normal;
					padding: 0 .28rem;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: .24rem;
					cursor: pointer;

					img {
						width: .36rem;
						height: auto;
						margin-left: .12rem;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cookie.vue